import { useState, useEffect } from 'react';
import type { WidgetDefinition, WidgetSlot } from '@yada/types';
import { runtime } from '../settings/runtimeRef';

/**
 * Returns all widgets registered for the given slot, re-rendering whenever
 * an app registers new widgets (i.e. on 'widgets:changed' events).
 */
export function useWidgets(slot: WidgetSlot): WidgetDefinition[] {
  const [widgets, setWidgets] = useState<WidgetDefinition[]>(() =>
    runtime.getWidgets(slot)
  );

  useEffect(() => {
    // Sync immediately in case widgets changed between render and effect
    setWidgets(runtime.getWidgets(slot));
    const unsub = runtime.on('widgets:changed', () => {
      setWidgets(runtime.getWidgets(slot));
    });
    return () => { unsub(); };
  }, [slot]);

  return widgets;
}
